import {Component} from '@angular/core';

@Component({
    selector: 'app-busy-indicator',
    template: `<img width="40px" src="/assets/img/loading.gif" style="position: absolute;left: 50%; top: 50%;">`
})
export class BusyIndicatorComponent {

}


// WEBPACK FOOTER //
// ./src/app/shared/busy.indicator.component.ts